module.exports = __webpack_public_path__ + "media/25.d6877134.wav";